import { Link } from 'react-router-dom';
import { useScrollAnimation, useStaggerAnimation } from '../../../hooks/useScrollAnimation';

export default function Testimonials() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: featuredRef, isVisible: featuredVisible } = useScrollAnimation();
  const { ref: cardsRef, getItemStyle } = useStaggerAnimation(3);

  return (
    <section className="py-16 lg:py-24 bg-brand-cream">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
        <div
          ref={headerRef}
          className="text-center mb-10 lg:mb-16"
          style={{
            opacity: headerVisible ? 1 : 0,
            transform: headerVisible ? 'translateY(0)' : 'translateY(40px)',
            transition: 'opacity 0.7s cubic-bezier(0.22, 1, 0.36, 1), transform 0.7s cubic-bezier(0.22, 1, 0.36, 1)',
          }}
        >
          <div className="inline-block bg-brand-red-light text-brand-red px-4 py-2 rounded-full text-sm font-semibold mb-4">
            CUSTOMER SUCCESS STORIES
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 mb-4">
            What Our Customers Say
          </h2>
        </div>

        <div
          ref={featuredRef}
          className="bg-brand-navy rounded-3xl overflow-hidden mb-8 lg:mb-12"
          style={{
            opacity: featuredVisible ? 1 : 0,
            transform: featuredVisible ? 'translateY(0) scale(1)' : 'translateY(30px) scale(0.98)',
            transition: 'opacity 0.8s cubic-bezier(0.22, 1, 0.36, 1), transform 0.8s cubic-bezier(0.22, 1, 0.36, 1)',
          }}
        >
          <div className="grid lg:grid-cols-3">
            <div className="relative h-56 sm:h-72 lg:h-auto">
              <img
                src="https://public.readdy.ai/ai/img_res/dba83ba4cd51e5ed10679e50167e3d22.jpg"
                alt="Customer"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="lg:col-span-2 p-6 sm:p-8 lg:p-12 flex flex-col justify-center">
              <div className="text-4xl lg:text-6xl text-brand-red mb-4 lg:mb-6">&ldquo;</div>
              <p className="text-white text-lg sm:text-xl lg:text-2xl xl:text-3xl font-light mb-6 lg:mb-8 leading-relaxed">
                Switching to solar and upgrading our HVAC cut our energy bills by 55%! The team was professional, and the savings calculator was spot-on accurate. Best home investment we've ever made.
              </p>
              <div className="mb-4 lg:mb-6">
                <div className="text-white text-lg lg:text-xl font-semibold mb-1">Michael Rodriguez</div>
                <div className="text-white/70">Homeowner, Miami, FL</div>
              </div>
              <Link
                to="/testimonials"
                className="inline-flex items-center gap-2 bg-brand-red text-white px-6 py-3 rounded-full font-semibold hover:bg-brand-red-dark transition-all duration-300 w-fit whitespace-nowrap"
              >
                Read More Reviews
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>

        <div ref={cardsRef} className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
          <div className="bg-white rounded-2xl p-6 shadow-lg" style={getItemStyle(0)}>
            <div className="flex items-center gap-3 mb-4">
              <svg viewBox="0 0 272 92" className="h-5 w-auto flex-shrink-0">
                <path fill="#EA4335" d="M115.75 47.18c0 12.77-9.99 22.18-22.25 22.18s-22.25-9.41-22.25-22.18C71.25 34.32 81.24 25 93.5 25s22.25 9.32 22.25 22.18zm-9.74 0c0-7.98-5.79-13.44-12.51-13.44S80.99 39.2 80.99 47.18c0 7.9 5.79 13.44 12.51 13.44s12.51-5.55 12.51-13.44z"/>
                <path fill="#FBBC05" d="M163.75 47.18c0 12.77-9.99 22.18-22.25 22.18s-22.25-9.41-22.25-22.18c0-12.85 9.99-22.18 22.25-22.18s22.25 9.32 22.25 22.18zm-9.74 0c0-7.98-5.79-13.44-12.51-13.44s-12.51 5.46-12.51 13.44c0 7.9 5.79 13.44 12.51 13.44s12.51-5.55 12.51-13.44z"/>
                <path fill="#4285F4" d="M209.75 26.34v39.82c0 16.38-9.66 23.07-21.08 23.07-10.75 0-17.22-7.19-19.66-13.07l8.48-3.53c1.51 3.61 5.21 7.87 11.17 7.87 7.31 0 11.84-4.51 11.84-13v-3.19h-.34c-2.18 2.69-6.38 5.04-11.68 5.04-11.09 0-21.25-9.66-21.25-22.09 0-12.52 10.16-22.26 21.25-22.26 5.29 0 9.49 2.35 11.68 4.96h.34v-3.61h9.25zm-8.56 20.92c0-7.81-5.21-13.52-11.84-13.52-6.72 0-12.35 5.71-12.35 13.52 0 7.73 5.63 13.36 12.35 13.36 6.63 0 11.84-5.63 11.84-13.36z"/>
                <path fill="#34A853" d="M225 3v65h-9.5V3h9.5z"/>
                <path fill="#EA4335" d="M262.02 54.48l7.56 5.04c-2.44 3.61-8.32 9.83-18.48 9.83-12.6 0-22.01-9.74-22.01-22.18 0-13.19 9.49-22.18 20.92-22.18 11.51 0 17.14 9.16 18.98 14.11l1.01 2.52-29.65 12.28c2.27 4.45 5.8 6.72 10.75 6.72 4.96 0 8.4-2.44 10.92-6.14zm-23.27-7.98l19.82-8.23c-1.09-2.77-4.37-4.7-8.23-4.7-4.95 0-11.84 4.37-11.59 12.93z"/>
                <path fill="#4285F4" d="M35.29 41.41V32H67c.31 1.64.47 3.58.47 5.68 0 7.06-1.93 15.79-8.15 22.01-6.05 6.3-13.78 9.66-24.02 9.66C16.32 69.35.36 53.89.36 34.91.36 15.93 16.32.47 35.3.47c10.5 0 17.98 4.12 23.6 9.49l-6.64 6.64c-4.03-3.78-9.49-6.72-16.97-6.72-13.86 0-24.7 11.17-24.7 25.03 0 13.86 10.84 25.03 24.7 25.03 8.99 0 14.11-3.61 17.39-6.89 2.66-2.66 4.41-6.46 5.1-11.65l-22.49.01z"/>
              </svg>
              <div className="flex text-brand-gold text-lg">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
              </div>
            </div>
            <p className="text-gray-700 text-sm mb-4">
              &ldquo;Outstanding service from start to finish. Our new heat pump is incredibly efficient and quiet. Highly recommend!&rdquo;
            </p>
            <div className="text-sm font-semibold text-gray-900">Sarah Johnson</div>
            <div className="text-xs text-gray-600">Tampa, FL</div>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-lg" style={getItemStyle(1)}>
            <div className="flex items-center gap-3 mb-4">
              <svg viewBox="0 0 24 24" className="w-6 h-6 flex-shrink-0" fill="none">
                <path d="M12 1.5l3.09 6.26L22 8.64l-5 4.87 1.18 6.88L12 17.27l-6.18 3.25L7 13.64 2 8.77l6.91-1.01L12 1.5z" fill="#00B67A"/>
              </svg>
              <span className="font-bold text-[#00B67A]">Trustpilot</span>
              <div className="flex text-[#00B67A] text-lg">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
              </div>
            </div>
            <p className="text-gray-700 text-sm mb-4">
              &ldquo;The attic insulation made a huge difference. Our home stays cooler and our AC doesn&apos;t run as much. Great ROI!&rdquo;
            </p>
            <div className="text-sm font-semibold text-gray-900">David Chen</div>
            <div className="text-xs text-gray-600">Orlando, FL</div>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-lg" style={getItemStyle(2)}>
            <div className="flex items-center gap-3 mb-4">
              <svg viewBox="0 0 100 100" className="w-10 h-10 flex-shrink-0">
                <rect width="100" height="100" rx="8" fill="#012E5E"/>
                <text x="50" y="42" fontFamily="Arial, sans-serif" fontWeight="900" fontSize="32" fill="white" textAnchor="middle">BBB</text>
                <circle cx="50" cy="70" r="18" fill="white"/>
                <text x="50" y="78" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="20" fill="#012E5E" textAnchor="middle">A+</text>
              </svg>
              <span className="font-bold text-gray-900">A+ Rating</span>
            </div>
            <p className="text-gray-700 text-sm mb-4">
              &ldquo;Professional installation, fair pricing, and excellent customer service. They helped us maximize all available rebates.&rdquo;
            </p>
            <div className="text-sm font-semibold text-gray-900">Jennifer Martinez</div>
            <div className="text-xs text-gray-600">Jacksonville, FL</div>
          </div>
        </div>
      </div>
    </section>
  );
}
